// @flow
import fileDownload from 'js-file-download';
import { addToSongList } from './songlist';
import { ThunkAction } from 'redux-thunk';
import type { MetaType, LineType } from '../types/entities';

// type DispatchType = (_: { type: string }) => void;
// type GetStateType = () => any;

export const NEW_SONG = 'NEW_SONG';

export const SAVE_SONG_REQUEST = 'SAVE_SONG_REQUEST';
export const SAVE_SONG_SUCCESS = 'SAVE_SONG_SUCCESS';
export const SAVE_SONG_FAILURE = 'SAVE_SONG_FAILURE';

export const LOAD_SONG_REQUEST = 'LOAD_SONG_REQUEST';
export const LOAD_SONG_SUCCESS = 'LOAD_SONG_SUCCESS';
export const LOAD_SONG_FAILURE = 'LOAD_SONG_FAILURE';

export const DOWNLOAD_SONG = 'DOWNLOAD_SONG';

export function newSong(meta: MetaType): { type: 'NEW_SONG', meta?: MetaType } {
  return { type: NEW_SONG, meta };
}

export function repairLine(line: LineType) {
  return {
    ...line,
    syllables:
      typeof line.syllables === 'string' ? parseInt(line.syllables, 10) || null : line.syllables,
    stresses:
      typeof line.stresses === 'string' ? parseInt(line.stresses, 10) || null : line.stresses,
  };
}

export function repairSong(song) {
  const newById = {};
  const { allIds } = song.lines;
  for (let i = 0; i < allIds.length; i += 1) {
    newById[allIds[i]] = repairLine(song.lines.byId[allIds[i]]);
  }
  return {
    ...song,
    lines: { ...song.lines, byId: newById },
  };
}

export function saveSong() {
  return (dispatch: DispatchType, getState: GetStateType) => {
    dispatch({ type: SAVE_SONG_REQUEST });

    return new Promise((resolve, reject) => {
      const state = getState().song;
      const filename = state.meta.filename.trim();
      if (filename.length > 0) {
        localStorage.setItem(`song-${filename}`, JSON.stringify(state));
        resolve(filename);
      } else {
        reject(new Error('No filename specified'));
      }
    })
      .then((filename) => {
        dispatch({ type: SAVE_SONG_SUCCESS });
        dispatch(addToSongList(filename, true));
      })
      .catch((err) => {
        dispatch({ type: SAVE_SONG_FAILURE, err });
      });
  };
}

export function downloadSong() {
  return (dispatch: DispatchType, getState: GetStateType) => {
    const song = getState().song;
    if (song) {
      fileDownload(
        JSON.stringify(song, null, 2),
        `${song.meta.filename || song.meta.title || 'Untitled'}.songbuilder.json`,
        'application/json',
      );
    }
    dispatch({ type: DOWNLOAD_SONG });
  };
}

export function loadSong(filename: string) {
  return (dispatch: DispatchType, getState: GetStateType) => {
    dispatch({ type: LOAD_SONG_REQUEST, filename });

    return new Promise((resolve, reject) => {
      const s = localStorage.getItem(`song-${filename}`);

      if (s) {
        const j = JSON.parse(s);
        if (j) {
          resolve(j);
          return;
        }
      }

      reject(s);
    })
      .then((obj) => {
        dispatch({ type: LOAD_SONG_SUCCESS, filename, obj: repairSong(obj) });
      })
      .catch((err) => {
        dispatch({ type: LOAD_SONG_FAILURE, err });
      });
  };
}

export function loadSongData(obj): ThunkAction {
  return (dispatch: DispatchType, getState: GetStateType) => {
    const {
      meta: { filename = '' },
    } = obj;
    dispatch({ type: LOAD_SONG_REQUEST, filename });
    dispatch({ type: LOAD_SONG_SUCCESS, filename, obj });
  };
}



// WEBPACK FOOTER //
// ./src/actions/song.js